import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, zIndex, getResetByTag, rem, shadows } from './../../styles';
import StyledButtonGroupItem from './styles/button-group.item.styles';
import StyledButtonGroupItemInput from './styles/button-group.item-input.styles';
import StyledButtonGroupItemText from './styles/button-group.item-text.styles';
import StyledButtonGroupItemOutline from './styles/button-group.item-outline.styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("background:", colors.coolGray_200, ";border:", rem(1), " solid ", colors.coolGray_500, ";border-radius:", rem(22), ";display:inline-flex;height:auto;padding:", rem(4), ";position:relative;z-index:", zIndex.zIndex_1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var hasStatusStyles = function hasStatusStyles(_ref2) {
  var hasSuccess = _ref2.hasSuccess,
    hasError = _ref2.hasError,
    hasWarning = _ref2.hasWarning,
    isInverse = _ref2.isInverse;
  if (hasSuccess === true) {
    return /*#__PURE__*/css(StyledButtonGroupItemInput, "{&:focus{&~", StyledButtonGroupItemText, "{color:", colors.navy_500, ";}&:checked{&~", StyledButtonGroupItemOutline, "{background-color:", colors.green_500, ";box-shadow:", rem(0, 0, 0, 4), " ", colors.lightBlue_500, ";}&~", StyledButtonGroupItemText, "{color:", colors.navy_500, ";}}}&:checked{&~", StyledButtonGroupItemOutline, "{background-color:", colors.green_500, ";box-shadow:", shadows.xs, ";}&~", StyledButtonGroupItemText, "{color:", colors.navy_500, ";}&:focus{background-color:", colors.green_500, ";}&:hover{background-color:", colors.green_500, ";}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:hasStatusStyles;"));
  }
  if (hasError === true) {
    return /*#__PURE__*/css(StyledButtonGroupItemInput, "{&:focus{&~", StyledButtonGroupItemText, "{color:", colors.navy_500, ";}&:checked{&~", StyledButtonGroupItemOutline, "{background-color:", !isInverse ? colors.red_500 : colors.red_400, ";box-shadow:", rem(0, 0, 0, 4), " ", colors.lightBlue_500, ";}&~", StyledButtonGroupItemText, "{color:", !isInverse ? colors.white : colors.navy_500, ";}}}&:checked{&~", StyledButtonGroupItemOutline, "{background-color:", !isInverse ? colors.red_500 : colors.red_400, ";box-shadow:", shadows.xs, ";}&~", StyledButtonGroupItemText, "{color:", !isInverse ? colors.white : colors.navy_500, ";}&:focus{background-color:", colors.red_500, ";}&:hover{background-color:", colors.red_500, ";}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:hasStatusStyles;"));
  }
  if (hasWarning === true) {
    return /*#__PURE__*/css(StyledButtonGroupItemInput, "{&:focus{&~", StyledButtonGroupItemText, "{color:", colors.yellow_500, ";}&:checked{&~", StyledButtonGroupItemOutline, "{background-color:", colors.yellow_500, ";box-shadow:", rem(0, 0, 0, 4), " ", colors.lightBlue_500, ";}&~", StyledButtonGroupItemText, "{color:", colors.navy_500, ";}}}&:checked{&~", StyledButtonGroupItemOutline, "{background-color:", colors.yellow_500, ";box-shadow:", shadows.xs, ";}&~", StyledButtonGroupItemText, "{color:", colors.navy_500, ";}&:focus{background-color:", colors.yellow_500, ";}&:hover{background-color:", colors.yellow_500, ";}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:hasStatusStyles;"));
  }
};
var isSizeStyles = function isSizeStyles(_ref3) {
  var size = _ref3.size;
  switch (size) {
    case 'sm':
      return /*#__PURE__*/css(StyledButtonGroupItem, "{height:", rem(26), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:isSizeStyles;"));
    case 'md':
      return /*#__PURE__*/css(StyledButtonGroupItem, "{height:", rem(34), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:isSizeStyles;"));
    case 'lg':
      return /*#__PURE__*/css(StyledButtonGroupItem, "{height:", rem(42), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:isSizeStyles;"));
  }
};
var isFluidStyles = function isFluidStyles(_ref4) {
  var isFluid = _ref4.isFluid;
  if (isFluid === true) {
    return /*#__PURE__*/css("width:100%;", StyledButtonGroupItem, "{flex:1 0 auto;}" + (process.env.NODE_ENV === "production" ? "" : ";label:isFluidStyles;"));
  }
};
var isErrorStyles = function isErrorStyles(_ref5) {
  var hasError = _ref5.hasError;
  if (hasError === true) {
    return /*#__PURE__*/css("border-color:", colors.red_500, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:isErrorStyles;"));
  }
};
var isWarningStyles = function isWarningStyles(_ref6) {
  var hasWarning = _ref6.hasWarning;
  if (hasWarning === true) {
    return /*#__PURE__*/css("border-color:", colors.yellow_500, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:isWarningStyles;"));
  }
};
var isSuccessStyles = function isSuccessStyles(_ref7) {
  var hasSuccess = _ref7.hasSuccess;
  if (hasSuccess === true) {
    return /*#__PURE__*/css("border-color:", colors.green_500, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:isSuccessStyles;"));
  }
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1e1ncky",
  styles: "border:none"
} : {
  name: "a7i8p5-isInverseBorderStyles",
  styles: "border:none;label:isInverseBorderStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var isInverseBorderStyles = function isInverseBorderStyles(_ref8) {
  var isInverse = _ref8.isInverse,
    hasError = _ref8.hasError,
    hasSuccess = _ref8.hasSuccess,
    hasWarning = _ref8.hasWarning;
  if (isInverse && !hasError && !hasSuccess && !hasWarning) {
    return _ref;
  }
};
var resetStyles = getResetByTag('div');
var StyledButtonGroup = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "efht5h60"
} : {
  target: "efht5h60",
  label: "StyledButtonGroup"
})(resetStyles, defaultStyles, hasStatusStyles, isSizeStyles, isFluidStyles, isErrorStyles, isSuccessStyles, isWarningStyles, isInverseBorderStyles);
export default StyledButtonGroup;